export default __webpack_public_path__ + "static/media/cancer8.afe597a4.jpg";